import { render, staticRenderFns } from "./UpdateEducation.vue?vue&type=template&id=288a58de&"
import script from "./UpdateEducation.vue?vue&type=script&lang=js&"
export * from "./UpdateEducation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports